import React from 'react';
import { NavLink } from 'react-router-dom';
import { useDispatch } from 'react-redux';
import {
  FiGrid,
  FiMapPin,
  FiMap,
  FiUsers,
  FiLogOut,
  FiCreditCard,
  FiFileText,
  FiHelpCircle,
  FiBell,
  FiHeart,
} from 'react-icons/fi';
import { logout } from '../../store/slices/authSlice';

const Sidebar = () => {
  const dispatch = useDispatch();

  const handleLogout = () => {
    dispatch(logout());
  };

  const navItems = [
    {
      section: 'Main',
      items: [
        { path: '/dashboard', icon: FiGrid, label: 'Dashboard' },
      ],
    },
    {
      section: 'User Management',
      items: [
        { path: '/users', icon: FiUsers, label: 'Users' },
        { path: '/subscriptions', icon: FiCreditCard, label: 'Subscriptions' },
      ],
    },
    {
      section: 'Content & Support',
      items: [
        { path: '/cms-pages', icon: FiFileText, label: 'CMS Pages' },
        { path: '/help-support', icon: FiHelpCircle, label: 'Help & Support' },
        { path: '/notifications', icon: FiBell, label: 'Notifications' },
      ],
    },
    {
      section: 'Location',
      items: [
        { path: '/states', icon: FiMap, label: 'States' },
        { path: '/cities', icon: FiMapPin, label: 'Cities' },
      ],
    },
  ];

  return (
    <aside className="sidebar">
      <div className="sidebar-header">
        <div className="sidebar-logo">
          <div className="sidebar-logo-icon">
            <FiHeart />
          </div>
          <span className="sidebar-logo-text">Dating Admin</span>
        </div>
      </div>

      <nav className="sidebar-nav">
        {navItems.map((section, index) => (
          <div className="nav-section" key={index}>
            <span className="nav-section-title">{section.section}</span>
            {section.items.map((item) => (
              <NavLink
                key={item.path}
                to={item.path}
                className={({ isActive }) =>
                  `nav-item ${isActive ? 'active' : ''}`
                }
              >
                <span className="nav-item-icon">
                  <item.icon />
                </span>
                <span>{item.label}</span>
              </NavLink>
            ))}
          </div>
        ))}
      </nav>

      <button className="logout-btn" onClick={handleLogout}>
        <FiLogOut />
        <span>Logout</span>
      </button>
    </aside>
  );
};

export default Sidebar;
